<template>
  <section class="mt-20 border-t border-slate-200">
    <Container>
      <SectionHeader>Contact</SectionHeader>
      <div class="flex flex-wrap justify-center gap-4 mb-16">
        <ContactAgent
          v-if="getAgent"
          :data="getAgent"
        />
        <ContactAgent :data="agent" v-for="agent in getMultiAgents" :key="agent.id" />
      </div>
      <div class="max-w-3xl mx-auto">
        <ContactForm />
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import ContactAgent from './components/ContactAgent';
  import ContactForm from './components/ContactForm';
  import Container from '../../components/Container';

  export default {
    name: 'Contact',
    components: {
      SectionHeader,
      ContactAgent,
      ContactForm,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getAgent', 'getMultiAgents'])
    }
  };
</script>
